import { Components } from "@mui/material";

export const MuiButtonBase: Components["MuiButtonBase"] = {
  defaultProps: {
    disableRipple: true, // No more ripple, on the whole application 💣!
  },
};
